module.exports = __webpack_public_path__ + "static/media/Analytics API - GBR Network - 08-10-2024 N.d74756c2.png";